export default __webpack_public_path__ + "static/media/logo.9e4bc342.png";